import { useState } from 'react';

import { Avatar, Button, Card, Col, Input, Row, Select, Tooltip, Typography } from 'antd';
import { Icon } from '@eduzz/ui-antd-theme';

import CustomMaskedInput from 'components/MaskedInput';
import type ICoProducer from 'interfaces/ICoProducer';

import { PartnerStatus } from '../../Status';

type SolidaritySquadFormProps = {
  index: number;
  onRemove: (index: number) => void;
  onChange: (field: string, index: number, value: string) => void;
  coproducer: ICoProducer;
};

function DiversityIcon() {
  return (
    <svg viewBox='0 0 24 24' fill='currentColor' focusable='false' className='size-5'>
      <circle cx='4' cy='14' r='2' />
      <path d='M1.22 17.58C.48 17.9 0 18.62 0 19.43V21h4.5v-1.61c0-.83.23-1.61.63-2.29-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58z' />
      <circle cx='20' cy='14' r='2' />
      <path d='M22.78 17.58c-.85-.37-1.79-.58-2.78-.58-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V21H24v-1.57c0-.81-.48-1.53-1.22-1.85zm-6.54-.93c-1.17-.52-2.61-.9-4.24-.9-1.63 0-3.07.39-4.24.9C6.68 17.13 6 18.21 6 19.39V21h12v-1.61c0-1.18-.68-2.26-1.76-2.74zM9 12c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z' />
      <path d='M2.48 10.86C2.17 10.1 2 9.36 2 8.6 2 6.02 4.02 4 6.6 4c2.68 0 3.82 1.74 5.4 3.59C13.57 5.76 14.7 4 17.4 4 19.98 4 22 6.02 22 8.6c0 .76-.17 1.5-.48 2.26.65.31 1.18.82 1.53 1.44.6-1.2.95-2.42.95-3.7C24 4.9 21.1 2 17.4 2c-2.09 0-4.09.97-5.4 2.51C10.69 2.97 8.69 2 6.6 2 2.9 2 0 4.9 0 8.6c0 1.28.35 2.5.96 3.7.35-.62.88-1.13 1.52-1.44z' />
    </svg>
  );
}

function SolidaritySquadForm({ index, onRemove, onChange, coproducer }: SolidaritySquadFormProps) {
  const [commissionError, setCommissionError] = useState('');

  function handleChange(field: string, index: number, value: string) {
    onChange(field, index, value);

    if (field === 'comission_value') {
      const commissionValue = Number(value.replace(',', '.'));
      const minimumCommissionValue = 0.01;

      if (commissionValue < minimumCommissionValue) {
        setCommissionError('O valor de porcentagem tem que ser no mínimo 0,01');
      } else {
        setCommissionError(null);
      }
    }
  }

  function showMoreElevar() {
    const ref = window.open('https://www.projetoelevar.org.br/#sobre-o-projeto', '_blank');
    ref.opener = null;
  }

  return (
    <Card size='small' className='h-full bg-(--uizz-antd-color-fill-alter)'>
      <div className='flex items-center justify-between p-4'>
        <div className='flex items-center gap-3'>
          <Avatar className='bg-(--uizz-antd-color-success)' icon={<DiversityIcon />} />
          <Typography.Text className='text-base'>Projeto social</Typography.Text>
        </div>
        <Tooltip title='Remover projeto social' placement='top'>
          <Button
            type='text'
            danger
            icon={<Icon.Trash2  />}
            onClick={() => onRemove(index)}
            aria-label='remover projeto social'
          />
        </Tooltip>
      </div>
      <div className='px-4 pb-4'>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Typography.Text className='mb-1 block text-base'>Nome do parceiro</Typography.Text>
            <Input disabled size='small' value={coproducer.business_name} />
          </Col>
          <Col xs={24} md={12}>
            <Typography.Text className='mb-1 block text-base'>Tipo de comissão</Typography.Text>
            <Select
              className='w-full'
              size='small'
              disabled
              value={coproducer.comission_type}
              onChange={value => handleChange('comission_type', index, value)}
              options={[{ value: 'P', label: 'Porcentagem' }]}
            />
          </Col>
          <Col xs={24} md={12}>
            <CustomMaskedInput
              mask='percent'
              label='Valor'
              helperText={commissionError}
              error={!!commissionError}
              startAdornment='%'
              fullWidth
              disableUnderline
              onChange={(value: string) => handleChange('comission_value', index, value)}
              value={String(coproducer.comission_value)}
              InputLabelProps={{ shrink: true }}
              InputProps={{ min: 0.01 }}
            />
          </Col>
        </Row>
      </div>
      <div className='mt-auto flex items-center justify-between border-t p-4'>
        <PartnerStatus cop={coproducer} />
        <Button onClick={showMoreElevar}>Saiba mais</Button>
      </div>
    </Card>
  );
}

export { SolidaritySquadForm };
